import React from "react";
import {Modal} from "antd";

const ShowMessage = ({item, showType = true}) => {

        function getStatusColor(item) {
            return item.final_status === 'Pending' ? 'orange' : 'green'
        }

        return (
            <div style={{marginRight: "5px", color: getStatusColor(item)}}
                 key={item.emp_code}>{`[${item.emp_code} - ${item.name}] ${showType && item.type !== 'FD' ? `(${item.type})` : ''}`}</div>
        )
    }
;
export default ShowMessage;
